import IOperaton from '../../IOperation'

/**
 * 叠置操作基类
 * 规定数据格式
 * 不做其他处理
 */
export default class IOverlay extends IOperaton {
    /**
     * @description 处理
     * @api
     * @param {{type:'FeatureCollection', features:[]}} featureCollections 要素集一
     * @param {{type:'FeatureCollection', features:[]}} featureCollections2 要素集二
     * @param {number} tolerance 容差
     */
    async _process(featureCollections, featureCollections2, tolerance) {}
}
